/**
 * 악덕마스터 상세 모달 — 마스터 목록 페이지(/adm/devil/masters)에서 사용.
 *
 *   // 페이지 초기화 시 1회
 *   $j.F.Admin.Devil.Master.config({ labels: {master, report, defense}, onChanged: reloadTable });
 *   // 상세 열기
 *   $j.F.Admin.Devil.Master.open(num);
 *
 *  - config.labels : 상태 라벨맵(@json(G5_DV_*) 주입). report/defense 는 제보 클릭 시 신고 모달로 전달.
 *  - config.onChanged : 해제/복구 성공 시 호출(목록 새로고침).
 *  - 제보목록 신고자/체불 클릭 → $j.F.Admin.Devil.Report 로 신고 모달(읽기전용)을 위에 스택.
 *
 * 데이터 단일 소스: GET /adm/ajax/devil/master/{num}
 */
import Util from '../../../Common/Util';
export default class Master {
    constructor() {
        this.ns        = '$j.F.Admin.Devil.Master'; // 인라인 onclick 용 네임스페이스
        this.modalId   = 'devil-master-detail';
        this.onChanged = null;
        this.host      = null;  // 통합모달 임베드 호스트(있으면 JBModal 대신 host 컨테이너에 렌더)
        this._mini     = false; // 임베드 축소형(신고자 목록만)
        this._selected = 0;     // 미니목록 선택 신고 num(노랑 표시)
        this._num      = 0;
        this.labels    = { master: {}, report: {}, defense: {} };
        this.REPORT_LABEL = { DRAFT: '작성중', SUBMITTED: '제출', APPROVED: '확인 완료', REJECTED: '반려', RECALLED: '해제' };
        this.ACTION_LABEL = { REGISTER: '등록', RELEASE: '해제', RESTORE: '복구', MERGE: '병합' };
    }

    // 페이지 1회 설정(라벨/콜백). open 에서 opts 로 덮어쓸 수도 있음.
    config = (opts = {}) => {
        if (opts.labels) this.labels = Object.assign({}, this.labels, opts.labels);
        if (opts.onChanged !== undefined) this.onChanged = opts.onChanged;
        return this;
    }

    open = (num, opts = {}) => {
        if (opts.labels) this.labels = Object.assign({}, this.labels, opts.labels);
        if (opts.onChanged !== undefined) this.onChanged = opts.onChanged;
        if (opts.host !== undefined) this.host = opts.host;
        this._mini     = !!opts.mini;
        this._selected = opts.selected || 0;
        this.modalId = opts.modalId || 'devil-master-detail';
        this._num = num;
        $.get('/adm/ajax/devil/master/' + num, res => this._render(res), 'json');
    }

    _render = (res) => {
        if (!res.result) { Util.swalert(res.message || '조회 실패'); return; }
        const m = res.master;
        this._teardownFullTables();

        // 통합모달(케이스) 카드 레이아웃 — 상단 요약카드 + 좌측 신고목록 을 각각 mount.
        if (this.host && this.host.mountSummary) {
            this.host.mountSummary(this._buildSummaryCard(res), m);
            this.host.mountList(this._buildReporterList(res), res.reports || [], m);
            return;
        }
        // (구) 통합모달 임베드 — 좌 단독/미니
        if (this.host) {
            if (this._mini) { this.host.mountMaster(this._buildMini(res), m, true); return; }
            this.host.mountMaster(this._buildFull(res), m, false);
            this._initFullTables();
            return;
        }
        // 단독 모달
        $j.Ui.JBModal.html(this.modalId, this._buildFull(res), `악덕업체 #${m.num}`, { width: '720px' });
        this._initFullTables();
    }

    // 임베드 축소형 — 신고자 세로목록(상태·체불·등록 한 줄). 선택행 노랑.
    _buildMini = (res) => {
        const ns = this.ns, m = res.master;
        const rows = (res.reports || []).map(r => `
            <div class="dvc-rep${Number(r.num) === Number(this._selected) ? ' is-selected' : ''}" data-rep="${r.num}" onclick="${ns}.report(${r.num})">
                <div class="dvc-rep-name">${this._esc(r.reporter_name || ('#' + r.mb_no))}</div>
                <div class="dvc-rep-sub">${this._esc(this._reportLabel(r.status))} · ${Number(r.unpaid_amount).toLocaleString()}원 · ${(r.created_at || '').substr(2, 8)}</div>
            </div>`).join('');
        return `
            <div class="dvc-mini-head">
                <a href="javascript:;" class="dvc-mini-co" onclick="${ns}.backToFull()" title="마스터 상세">${this._esc(m.co_name || '-')} <i class="fa fa-caret-down"></i></a>
                <div class="dvc-mini-meta">${this._badge(m.status)} · 체불 ${Number(m.unpaid_total).toLocaleString()}원 · 신고 ${m.report_cnt || 0}</div>
            </div>
            <div class="dvc-mini-list">${rows || '<div class="text-muted" style="padding:10px;font-size:12px">제보 없음</div>'}</div>`;
    }

    // 미니목록에서 마스터 상세(full)로 복귀 — 통합모달이 우측 닫고 A상태로.
    backToFull = () => { if (this.host && this.host.onBackToFull) this.host.onBackToFull(); }

    // ── 케이스 카드 레이아웃 빌더 ──────────────────────────────
    // 상단 요약카드(핑크) — 태그/업체명/상태 + 해제버튼, 기본정보 칩그리드 + 변경내역 타임라인.
    _buildSummaryCard = (res) => {
        const ns = this.ns, m = res.master;
        const PHONE_COLORS = ['#2563eb', '#0891b2', '#7c3aed', '#059669', '#d97706', '#db2777'];
        const phones = (res.phones || []).length
            ? (res.phones || []).map((p, i) => `<span class="dvc2-phone" style="background:${PHONE_COLORS[i % PHONE_COLORS.length]}">${this._esc(Util.phoneNumber(p.phone) || p.phone)}</span>`).join('')
            : '<span class="text-muted">-</span>';

        this._logs = res.logs || [];
        const reportCnt = (res.reports || []).length || m.report_cnt || 0;

        // 체불 해제/복구 버튼 — 참고파일 네이밍·색상 그대로.
        //  REG      → '체불 해제'            (다크 배경/흰 글자)
        //  RELEASED → '체불 해제됨 · 되돌리기' (흰 배경/빨강 글자·테두리)
        const actionBtn = m.status === 'REG'
            ? `<button type="button" class="dvc2-release" onclick="${ns}.release(${m.num})">체불 해제</button>`
            : m.status === 'RELEASED'
                ? `<button type="button" class="dvc2-release released" onclick="${ns}.restore(${m.num})">체불 해제됨 · 되돌리기</button>` : '';

        // 변경내역 아코디언(기본 접힘) — 요약카드 우측 '처리내역' 버튼으로 토글
        const logRows = (this._logs).map(l => `
            <div class="dvc2-logitem">
                <span class="dvc2-logt">${this._esc((l.created_at || '').substr(0, 16))}</span>
                <span class="dvc2-logm"><b>${this._esc(this._actionLabel(l.action))}</b>${l.memo ? ' ' + this._esc(l.memo) : ''}</span>
                <span class="dvc2-logby">${this._logActor(l)}</span>
            </div>`).join('') || '<div class="dvc2-logempty">변경내역 없음</div>';

        // 상단영역 — 참고파일 레이아웃: 연락처 강조 → 체불금액 큰 숫자 → 인라인 메타
        return `
            <div class="dvc2-top-head">
                <span class="dvc2-co">${this._esc(m.co_name || '-')}</span>
                ${this._badge(m.status)}
                <span class="dvc2-spacer"></span>
                <button type="button" class="dvc2-logbtn" onclick="${ns}.toggleLogs()">처리내역 <span class="dvc2-logcount">${this._logs.length}</span> <span class="dvc2-caret">▾</span></button>
                ${actionBtn}
            </div>
            <div class="dvc2-info">
                <div class="dvc2-phones-row">
                    <span class="dvc2-info-lbl">대표번호</span>
                    <div class="dvc2-phones">${phones}</div>
                </div>
                <div class="dvc2-meta-row">
                    <div class="dvc2-total"><span class="dvc2-info-lbl">체불금액</span><b>${Number(m.unpaid_total).toLocaleString()}원</b></div>
                    <div class="dvc2-meta">
                        <span><i>제보</i>${reportCnt}건</span>
                        <span><i>회수</i><b style="color:var(--adm-c-1565c0, #1565c0)">${Number(m.recovered_total || 0).toLocaleString()}원</b></span>
                        <span><i>사업자</i>${this._esc(m.biz_no || '-')}</span>
                        <span><i>대표</i>${this._esc(m.ceo_name || '-')}</span>
                        <span><i>주소</i>${this._esc(m.address || '-')}</span>
                        <span><i>등록</i>${this._esc(m.created_at ? String(m.created_at).substr(0, 16) : '-')}</span>
                    </div>
                </div>
            </div>
            <div class="dvc2-logpanel" style="display:none">${logRows}</div>`;
    }

    // 변경내역 인라인 아코디언 토글 (요약카드 '처리내역' 버튼). 케이스 모달 1개만 떠 있음.
    toggleLogs = () => {
        const $b = $('.dvc2-logbtn'), $p = $('.dvc2-logpanel');
        const open = !$b.hasClass('open');
        $b.toggleClass('open', open);
        $b.find('.dvc2-caret').text(open ? '▴' : '▾');
        $p.stop(true, true).slideToggle(140);
    }

    // 좌측 신고건 목록(파랑 카드) — 번호 + 이름 + 체불/상태/등록일, 검색.
    _buildReporterList = (res) => {
        const ns = this.ns;
        const firstNum = (res.reports && res.reports[0]) ? res.reports[0].num : '';
        const rows = (res.reports || []).map((r, i) => {
            const badge = r.status === 'RECALLED'
                ? this._reportBadge('RECALLED')                                  // 해제(철회) — 회수보다 우선
                : r.recovered_at
                    ? '<span class="dvc2-rbadge dvc2-rbadge-REC">회수</span>'
                    : this._reportBadge(r.status);
            return `
            <div class="dvc2-rep${Number(r.num) === Number(this._selected) ? ' is-selected' : ''}" data-rep="${r.num}"
                 data-key="${this._esc((r.reporter_name || '') + ' #' + r.num + ' ' + r.mb_no)}" onclick="${ns}.report(${r.num})">
                <span class="dvc2-rep-no">${i + 1}</span>
                <div class="dvc2-rep-main">
                    <div class="dvc2-rep-name">${this._esc(r.reporter_name || '회원')}<small class="text-muted">#${$j.F.Admin.Member.Pop.cellNo(r.mb_no, { stop: true })}</small></div>
                    <div class="dvc2-rep-sub"><b>${Number(r.unpaid_amount).toLocaleString()}원</b> ${badge}
                        <span class="dvc2-rep-date">${(r.created_at || '').substr(2, 8)}</span></div>
                </div>
            </div>`;
        }).join('') || '<div class="text-muted" style="padding:14px;font-size:13px">제보 없음</div>';

        return `
            <div class="dvc2-list-head"><span class="dvc2-list-badge">신고건 목록(최신순) · <b>${(res.reports || []).length}</b>건</span></div>
            <div class="dvc2-search">
                <i class="fa fa-search"></i>
                <input type="text" placeholder="이름 또는 번호(#${firstNum}) 검색" oninput="${ns}.filterList(this.value)">
            </div>
            <div class="dvc2-rep-list">${rows}</div>`;
    }

    // 신고목록 클라이언트 필터(이름/번호). 케이스 모달 1개만 떠 있으므로 전역 셀렉터 사용.
    filterList = (q) => {
        q = String(q || '').toLowerCase().trim();
        $('.dvc2-rep').each(function () {
            const key = String($(this).data('key') || '').toLowerCase();
            $(this).toggle(!q || key.indexOf(q) >= 0);
        });
    }

    _reportBadge = (s) => `<span class="dvc2-rbadge dvc2-rbadge-${s}">${this._esc(this._reportLabel(s))}</span>`;

    // 전체형(full) 빌더 — 마스터정보 + 제보목록(DataTable) + 변경이력(DataTable) + 해제/복구.
    _buildFull = (res) => {
        const m = res.master;
        const ns = this.ns;
        // 연락처 — 번호마다 색 칩으로 분리(가독성). 콤마 나열 대신.
        const PHONE_COLORS = ['#2563eb', '#0891b2', '#7c3aed', '#059669', '#d97706', '#db2777'];
        const phones = (res.phones || []).length
            ? (res.phones || []).map((p, i) => {
                const c = PHONE_COLORS[i % PHONE_COLORS.length];
                return `<span style="display:inline-block;font-weight:600;color:#fff;background:${c};`
                     + `border-radius:10px;padding:1px 8px;margin:2px 4px 2px 0;white-space:nowrap">`
                     + `${this._esc(Util.phoneNumber(p.phone))}</span>`;
            }).join('')
            : '-';

        const reportRows = (res.reports || []).map(r => `<tr>
            <td><a href="javascript:;" onclick="${ns}.report(${r.num})">${this._esc(r.reporter_name || '회원')}</a><small class="text-muted">#${$j.F.Admin.Member.Pop.cellNo(r.mb_no)}</small></td>
            <td>${this._esc(this._reportLabel(r.status))}</td>
            <td class="text-right">${Number(r.unpaid_amount).toLocaleString()}원</td>
            <td class="text-center">${r.recovered_at ? String(r.recovered_at).substr(0, 10) : '-'}</td>
            <td style="white-space:nowrap">${(r.created_at || '').substr(2, 8)}</td>
        </tr>`).join('');

        const logRows = (res.logs || []).map(l => `<tr>
            <td style="white-space:nowrap">${this._esc((l.created_at || '').substr(0, 16))}</td>
            <td style="white-space:nowrap">${this._esc(this._actionLabel(l.action))}</td>
            <td>${this._logActor(l)}</td>
            <td>${this._esc(l.memo || '-')}</td>
        </tr>`).join('');

        const html = `
            <table class="table table-sm" style="font-size:12px;margin-bottom:0">
                <tbody>
                    <tr><th width="110">업체명</th><td>${this._esc(m.co_name || '-')}</td></tr>
                    <tr><th>사업자번호</th><td>${this._esc(m.biz_no || '-')}</td></tr>
                    <tr><th>대표자</th><td>${this._esc(m.ceo_name || '-')}</td></tr>
                    <tr><th>주소</th><td>${this._esc(m.address || '-')}</td></tr>
                    <tr><th>연락처</th><td>${phones}</td></tr>
                    <tr><th>체불합계</th><td><b>${Number(m.unpaid_total).toLocaleString()}</b>원</td></tr>
                    <tr><th>상태</th><td>${this._badge(m.status)}</td></tr>
                </tbody>
            </table>
            <h6 class="mt-3">제보목록</h6>
            <table id="dvm-reports" class="table table-sm table-bordered display" style="font-size:11px;width:100%">
                <thead><tr><th>신고자</th><th>상태</th><th>체불</th><th>회수</th><th>등록</th></tr></thead>
                <tbody>${reportRows}</tbody>
            </table>
            <h6 class="mt-3">변경이력</h6>
            <table id="dvm-logs" class="table table-sm table-bordered display" style="font-size:11px;width:100%">
                <thead><tr><th>일시</th><th>처리</th><th>처리자</th><th>비고</th></tr></thead>
                <tbody>${logRows}</tbody>
            </table>
            ${m.status === 'REG' ? `<div class="dv-modal-actions"><button class="btn btn-danger btn-sm" onclick="${ns}.release(${m.num})">악덕 해제</button></div>`
              : m.status === 'RELEASED' ? `<div class="dv-modal-actions"><button class="btn btn-primary btn-sm" onclick="${ns}.restore(${m.num})">악덕 복구</button></div>` : ''}
        `;
        return html;
    }

    _teardownFullTables = () => {
        ['#dvm-reports', '#dvm-logs'].forEach(sel => { if ($.fn.DataTable.isDataTable(sel)) $(sel).DataTable().destroy(); });
    }
    _initFullTables = () => {
        const dtOpt = {
            autoWidth: false, searching: false, lengthChange: false, info: false, ordering: false, pageLength: 5,
            language: { emptyTable: '내역 없음', paginate: { previous: "<i class='fa fa-chevron-left'></i>", next: "<i class='fa fa-chevron-right'></i>" } }
        };
        new DataTable('#dvm-reports', dtOpt);
        new DataTable('#dvm-logs', dtOpt);
    }

    // 통화 클릭 → 통화목록 모달. 통화자(이름#회원번호)/공유토글/통화시간(초)/통화일시.
    openCalls = (num) => {
        $.get('/adm/ajax/devil/master/' + num + '/calls', res => this._renderCalls(num, res), 'json');
    }

    _renderCalls = (masterNum, res) => {
        if (!res.result) { Util.swalert(res.message || '조회 실패'); return; }
        const ns = this.ns;
        const rows = (res.calls || []).map(c => `<tr>
            <td>
                <a href="javascript:;" class="cell-detail" title="제보자 모바일"
                   onclick="$j.F.Admin.Util.devilMobile(${c.mb_no})">${this._esc(c.name)}</a><span class="text-muted" style="margin-left:1px">#${$j.F.Admin.Member.Pop.cellNo(c.mb_no)}</span>
            </td>
            <td class="text-center">
                <label class="dv-switch" title="${c.is_shared ? '공유' : '비공유'}">
                    <input type="checkbox" data-mb="${c.mb_no}" ${c.is_shared ? 'checked' : ''}
                        onchange="${ns}.toggleShare(${masterNum}, ${c.mb_no}, this.checked)">
                    <span></span>
                </label>
            </td>
            <td class="text-center">${c.duration != null ? this._fmtDur(c.duration) : '-'}</td>
            <td class="text-center" style="white-space:nowrap">${this._esc(c.call_time || '-')}</td>
        </tr>`).join('');

        const html = `
            <table id="dvm-calls" class="table table-sm table-bordered display" style="font-size:12px;width:100%">
                <thead><tr><th>통화자</th><th width="70">공유</th><th width="90">통화시간</th><th width="120">통화일시</th></tr></thead>
                <tbody>${rows}</tbody>
            </table>`;
        if ($.fn.DataTable.isDataTable('#dvm-calls')) $('#dvm-calls').DataTable().destroy();
        $j.Ui.JBModal.html('devil-master-calls', html, `통화목록 #${masterNum}`, { width: '560px' });
        new DataTable('#dvm-calls', {
            autoWidth: false, searching: false, lengthChange: false, info: false, ordering: false, pageLength: 10,
            language: { emptyTable: '통화 내역 없음', paginate: { previous: "<i class='fa fa-chevron-left'></i>", next: "<i class='fa fa-chevron-right'></i>" } }
        });
    }

    // 공유설정 토글 — g5_dv_share_prefs 명시 결정 기록(mb_no·master_num 단위 단일 결정).
    // 공유는 사람 단위라 같은 회원(mb_no)의 통화행을 한꺼번에 동기화한다(실패 시 전부 원복).
    toggleShare = (masterNum, mbNo, isShared) => {
        const apply = (val) => $('#dvm-calls input[data-mb="' + mbNo + '"]').each(function () {
            this.checked = val;
            $(this).closest('.dv-switch').attr('title', val ? '공유' : '비공유');
        });
        $.post('/adm/ajax/devil/master/' + masterNum + '/call-share',
            { mb_no: mbNo, is_shared: isShared ? 1 : 0 }, res => {
                if (!res.result) { Util.swalert(res.message || '공유 설정 실패'); apply(!isShared); return; }
                apply(isShared);
                $j.Ui.Toast.show(isShared ? '공유함' : '공유 안 함', { type: 'success' });
            }, 'json').fail(() => { Util.swalert('공유 설정 실패'); apply(!isShared); });
    }

    // 초 → "M분 S초" (1분 미만은 "S초")
    _fmtDur = (sec) => {
        sec = Number(sec) || 0;
        const m = Math.floor(sec / 60), s = sec % 60;
        return m > 0 ? `${m}분 ${s}초` : `${s}초`;
    }

    // 제보 신고자/체불 클릭 → 통합모달이면 우측 신고 pane 으로, 단독이면 신고 모달 스택(읽기전용).
    report = (num) => {
        if (this.host && this.host.onSelectReport) { this.host.onSelectReport(num); return; }
        $j.F.Admin.Devil.Report.open(num, {
            readOnly: true,
            modalId: 'devil-report-view',
            labels: { report: this.labels.report, defense: this.labels.defense, master: this.labels.master },
        });
    }

    // 해제/복구 — 목록 관리버튼/모달 공용. 성공 시 모달 닫고 onChanged.
    release = (num) => {
        Util.swalert('해제하면 공개 목록/통화 경고에서 제외됩니다.\n해제할까요?', () => {
            $.post('/adm/ajax/devil/master/' + num + '/release', res => this._after(res, '해제되었습니다.'), 'json');
        });
    }
    restore = (num) => {
        Util.swalert('복구하면 공개 목록/통화 경고에 다시 노출됩니다.\n복구할까요?', () => {
            $.post('/adm/ajax/devil/master/' + num + '/restore', res => this._after(res, '복구되었습니다.'), 'json');
        });
    }
    _after = (res, okMsg) => {
        if (!res.result) { Util.swalert(res.message || '처리 실패'); return; }
        $j.Ui.JBModal.close && $j.Ui.JBModal.close(this.modalId);
        if (this.onChanged) this.onChanged();
        $j.Ui.Toast.show(okMsg, { type: 'success' });
    }

    // ── 헬퍼 ────────────────────────────────────────────────
    _esc = (s) => String(s == null ? '' : s).replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
    _badge = (s) => `<span class="badge-status badge-${s}">${this._esc((this.labels.master && this.labels.master[s]) || s)}</span>`;
    _reportLabel = (s) => this.REPORT_LABEL[s] || s;
    _actionLabel = (a) => this.ACTION_LABEL[a] || a;
    /** 변경내역 담당자 — 관리자면 이름. 관리자번호 0 인 해제·복구는 제보자가 앱에서 회수(취소)해 따라온 자동 처리, 그 밖(등록 배치)은 시스템 */
    _logActor = (l) => {
        if (l.manager_name) return this._esc(l.manager_name);
        if (String(l.manage_num) !== '0') return '#' + this._esc(l.manage_num);
        if (l.action === 'RELEASE' || l.action === 'RESTORE') return '제보자(자동)';
        return '시스템';
    }
}
